import { computed, defineComponent } from "vue";
import { useAccountStore } from 'src/stores/account';
import { useCentralStore } from 'src/stores/central';
import { AppStringMethods } from 'src/plugins/string/stringMethods';
import { AppCurrencyMethod } from "src/plugins/string/currency";
export default defineComponent({
    name: 'header-cashback',
    props: {
        homeHeader: Boolean
    },
    setup() {
        const accountStore = useAccountStore();
        const centralStore = useCentralStore();
        const requeryInit = computed(() => centralStore.requeryInit);
        const requerying = computed(() => centralStore.requeryingInit);
        const profileCashback = computed(() => accountStore.currentCountryFlexCredits);
        const user = computed(() => accountStore.user);
        const userMisc = computed(() => accountStore.userMisc);
        const { numberWithCommas } = AppStringMethods();
        const userCountry = computed(() => userMisc.value?.current_country_detail.current_country_code || "");
        const { countryCurrency } = AppCurrencyMethod(userCountry);
        return {
            requeryInit,
            requerying,
            profileCashback,
            user,
            countryCurrency,
            numberWithCommas
        };
    }
});
